import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row
} from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import React, { Fragment } from "react";

import { CancelButton } from "../../elements/ActionButtons/CancelButton";
import CustomDatetime from "../../elements/CustomDatetime/CustomDatetime";
// import ClientProjectSelect from "../ClientProject/ClientProjectSelect";
import { DeleteButton } from "../../elements/ActionButtons/DeleteButton";
import ProjectSelect from "../Project/ProjectSelect";
import Queries from "../../queries/queries2";
import { Query } from "react-apollo";
import { SaveButton } from "../../elements/ActionButtons";
import Spinner from "../../elements/Spinner/Spinner";
import Switch from "react-bootstrap-switch";
import { compose } from "recompose";
import moment from "moment";

class BudgetItemsBackupForm extends React.Component {
  constructor(props) {
    super(props);

    // form state
    this.state = {
      ...props.values,
      errors: {}
    };

    // console.log("34 - props", props);
    // console.log("35 - state", this.state);
  }

  validate = () => {
    const errors = {
      nameError: this.state.name === "" ? "error" : null,
      dateDebutError: !!!this.state.dateDebut ? "error" : null
    };
    this.setState({ errors });

    return !!!errors.yearError;
    // && !!!errors.monthError;
  };

  componentDidUpdate = (prevProps, prevState) => {
    // const variables = {
    //   companyId: this.state.companyId,
    //   tiersId: this.state.tiersId
    // };
    // const res = await this.props.getBudgetItems.refetch(variables);
    // console.log("res", res);
  };

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("61 - getDerivedStateFromProps", props, state);
    // if (
    //   props.values &&
    //   props.values.previousNextCommand &&
    //   (props.values.tiersId !== state.tiersId ||
    //     props.values.categoryId !== state.categoryId ||
    //     props.values.projectId !== state.projectId ||
    //     props.values.isReal !== state.isReal)
    // ) {
    //   dateDebut: values.dateDebut,
    //   observations: values.observationsd = props.values.tiersId;
    //   state.isReal = props.values.isReal;
    //   state.originalItemsData = undefined;
    //   state.originalIsRealData = undefined;
    //   props.values.previousNextCommand = false;
    // }
  };

  render = () => {
    const {
      intl,
      sendNotification,
      cancel,
      save,
      deleteBudgetItems,
      currencyId,
      workInProgress
      // companyId
      // disabled,
      //tiersId
    } = this.props;

    const locale = `${intl.locale.split("-")[0]}`;

    let { dateDebut, companyId, errors } = this.state;

    // let saveDisable = true;
    let saveDisable = false;
    // if (this.state.originalItemsData) {
    //   if (
    //     this.state.originalItemsData !== JSON.stringify(this.state.items) ||
    //     this.state.originalIsRealData !== this.state.isReal
    //   ) {
    //     saveDisable = false;
    //   }
    // }
    // console.log("109 - saveDisable=", saveDisable);

    // console.log("113 - data=",
    //   companyId,
    //   tiersId,
    //   year,
    //   projectId
    // );

    const disabled = false;
    return (
      <React.Fragment>
        <Row>
          <Col xs={12} sm={10}>
            <FormGroup validationState={this.state.errors.nameValidation}>
              <ControlLabel>
                {intl.formatMessage({ id: "ids_backupName" })}
              </ControlLabel>
              <FormControl
                name="name"
                id="name"
                value={this.state.name}
                placeholder={intl.formatMessage({ id: "ids_name" })}
                onChange={event => {
                  return this.setState({ name: event.target.value });
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={10}>
            <FormGroup
              style={{
                // marginTop: "55px",
                marginBottom: "0"
              }}
              validationState={this.state.errors.dateDebutValidation}
            >
              <ControlLabel>
                <FormattedMessage id="ids_dateDebut" />
              </ControlLabel>

              <CustomDatetime
                // dateFormat={"YYYY-MM"}
                inputProps={{
                  onClick: e => e.target.select()
                  //disabled: disableDate
                }}
                locale={locale}
                defaultValue={this.state.dateDebut}
                onBlur={e => {
                  console.log("date:", e);
                  this.setState({ dateDebut: e.startOf("month") });
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={10}>
            <FormGroup>
              <ControlLabel>
                <FormattedMessage id="ids_observations" />
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                rows="10"
                name="observations"
                id="observations"
                defaultValue={this.state.observations}
                placeholder={intl.formatMessage({ id: "ids_observations" })}
                onBlur={event =>
                  this.setState({ observations: event.target.value })
                }
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={5}>
            <div className="side-modal-footer">
              <SaveButton
                className="btn-fill pull-right"
                disabled={saveDisable}
                workInProgress={!!workInProgress}
                onMouseDown={() =>
                  setTimeout(() => {
                    if (this.validate()) {
                      console.log("273 - OnClisk SAVE...");
                      const data = JSON.stringify(this.state.items);
                      this.setState({ originalItemsData: data });
                      save(this.state);
                    }
                  }, 250)
                }
              />
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  };
}

export default compose(injectIntl)(BudgetItemsBackupForm);
